import { Card, CardBody, Col, Table } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { ActiveOrderHeading } from "../../../../utils/Constant";
import ActiveOrderTableHeader from "./ActiveOrderTableHeader";
import ActiveOrderTableBody from "./ActiveOrderTableBody";

const ActiveOrder = () => {
  return (
    <Col xxl="6" xl="7" className="box-col-7 proorder-xl-4 proorder-lg-4">
      <Card className="activeorder">
        <CardHeaderCommon title={ActiveOrderHeading} />
        <CardBody className="pt-0">
          <div className="custom-scrollbar">
            <Table responsive className="display w-100" id="active-order" >
              <ActiveOrderTableHeader />
              <ActiveOrderTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ActiveOrder;
